import Vue from 'vue'
import VueCarousel from 'vue-carousel';

import Feedback from './feedback-message.vue'

import { randomString, isObjectEmpty, appendStyle } from '../../util'

import { feedbackContentEditor, feedbackDesignEditor } from './feedback-message.widget.mock';

function render(container, props, options) {
  Vue.component('ae-widget-feedback-message', Feedback)
  Vue.use(VueCarousel)

  const wrapper = document.createElement('div')
  wrapper.id = randomString(15)

  container.innerHTML = ''
  container.appendChild(wrapper)

  new Vue({
    el: `#${wrapper.id}`,
    template:
    `<ae-widget-feedback-message
      :itemsPerPage="itemsPerPage"
      :dataList="dataList"
      :device=device
      :paginationColor=paginationColor
      :paginationActiveColor=paginationActiveColor
      :paginationEnabled=paginationEnabled
      :navigationEnabled=navigationEnabled
      :autoplay=autoplay
      :autoplayTimeout=autoplayTimeout
      :autoplayHoverPause=autoplayHoverPause
      :loop=loop
      :speed=speed
      :easing=easing
      :iconSrc=iconSrc
    ></ae-widget-feedback-message>`,
    data: function() {
      return {
        iconSrc: props.iconSrc,
        itemsPerPage: parseInt(props.itemsPerPage),
        dataList: props.feedbackList || [],
        device: options.device,
        navigationEnabled: props.navigationEnabled,
        paginationEnabled: props.paginationEnabled,
        paginationColor: props.paginationColor,
        paginationActiveColor: props.paginationActiveColor,
        autoplay: props.autoplay,
        autoplayTimeout: props.autoplayTimeout,
        autoplayHoverPause: props.autoplayHoverPause,
        loop: props.loop,
        speed: props.speed,
        easing: props.easing
      }
    }
  })
}

export function init({ container, props, ...additionalData }) {
  if (isObjectEmpty(props)) {
    props = {}
  }

  if (location.hostname === 'localhost') {
    // Mocking device on localhost
    // additionalData.device = 'mobile'

    console.log(feedbackContentEditor)

    // Mocking data on localhost
    props = {
      iconSrc: feedbackContentEditor.iconSrc,
      feedbackList: feedbackContentEditor.feedbackList,
      itemsPerPage: feedbackDesignEditor.itemsPerPage,
      navigationEnabled: feedbackDesignEditor.navigationEnabled,
      paginationEnabled: feedbackDesignEditor.paginationEnabled,
      paginationColor: feedbackDesignEditor.paginationColor,
      paginationActiveColor: feedbackDesignEditor.paginationActiveColor,
      autoplay: feedbackContentEditor.autoplay,
      autoplayTimeout: feedbackContentEditor.autoplayTimeout,
      autoplayHoverPause: feedbackContentEditor.autoplayHoverPause,
      loop: feedbackContentEditor.loop,
      speed: feedbackContentEditor.speed,
      easing: feedbackContentEditor.easing
    }
  }

  render(container, props, additionalData)
  appendStyle('https://use.fontawesome.com/releases/v5.8.1/css/all.css', 'font-awesome')
}

export function clean({ container }) {
  container.innerHTML = ''
}

//#region Registering widget in Duda

/**
 * For code that is written without a build system (or that is not built as amd),
 * some additional properties should be passed (namely, amd and name):
 * The App should expose init and clean as well.
 * docs: https://developer.duda.co/docs/external-js-apps
 * example: https://github.com/DudaDev/react-widget-demo/blob/no-amd/src/index.js
 */
(function (global) {
  if (!global || !global.dmAPI) return; // Added check to prevent errors in demo
  global.dmAPI.registerExternalWidget('feedback-message', {
    init,
    clean
  })
})(window)

//#endregion
